import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || '';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

const withSessionHeader = (sessionId, config = {}) => ({
  ...config,
  headers: {
    ...(config.headers || {}),
    ...(sessionId ? { 'X-Session-Id': sessionId } : {}),
  },
});

// Submissions
export const createSubmission = async (userData, sessionId, capacitacionId = null, formVariant = 'classic', password = '') => {
  const response = await api.post('/api/submissions', {
    user: userData,
    session_id: sessionId,
    capacitacion_id: capacitacionId,
    form_variant: formVariant,
    ...(password ? { password } : {}),
  });
  return response.data;
};

export const getSubmission = async (submissionId, sessionId) => {
  const response = await api.get(
    `/api/submissions/${submissionId}`,
    withSessionHeader(sessionId)
  );
  return response.data;
};

export const getSubmissionBySession = async (sessionId) => {
  const response = await api.get(`/api/submissions/by-session/${sessionId}`);
  return response.data;
};

export const consumePortalFormHandoff = async (token) => {
  const response = await api.post(
    `/api/portal-form-handoffs/${encodeURIComponent(token)}/consume`
  );
  return response.data;
};

export const updateSubmission = async (submissionId, data, sessionId) => {
  const response = await api.put(
    `/api/submissions/${submissionId}`,
    data,
    withSessionHeader(sessionId)
  );
  return response.data;
};

export const saveSubmissionForLater = async (submissionId, sessionId, data) => {
  const response = await api.post(
    `/api/submissions/${submissionId}/save-for-later`,
    data,
    withSessionHeader(sessionId)
  );
  return response.data;
};

export const configureSubmissionRmPassword = async (submissionId, sessionId, password) => {
  const response = await api.post(
    `/api/submissions/${submissionId}/rm-password`,
    { password },
    withSessionHeader(sessionId)
  );
  return response.data;
};

export const finalizeSubmission = async (submissionId, sessionId) => {
  const response = await api.post(
    `/api/submissions/${submissionId}/finalize`,
    {},
    withSessionHeader(sessionId)
  );
  return response.data;
};

export const createAudioToken = async (submissionId, sessionId) => {
  const response = await api.post(
    `/api/submissions/${submissionId}/audio-token`,
    {},
    withSessionHeader(sessionId)
  );
  return response.data;
};

export const getAudioSubmission = async (token) => {
  const response = await api.get(`/api/audio-submissions/${token}`);
  return response.data;
};

export const configureAudioRmPassword = async (token, password) => {
  const response = await api.post(`/api/audio-submissions/${token}/rm-password`, { password });
  return response.data;
};

export const saveAudioPhrases = async (token, phrases) => {
  const response = await api.put(`/api/audio-submissions/${token}/phrases`, { phrases });
  return response.data;
};

export const uploadAudioSubmission = async (token, file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await api.post(`/api/audio-submissions/${token}/upload`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const skipAudioSubmission = async (token) => {
  const response = await api.post(`/api/audio-submissions/${token}/skip`);
  return response.data;
};

export const generateAffirmationIdeas = async (submissionId, sessionId, currentPhrases = []) => {
  const response = await api.post(
    `/api/submissions/${submissionId}/affirmation-ideas`,
    { current_phrases: currentPhrases },
    withSessionHeader(sessionId)
  );
  return response.data;
};

// Capacitaciones (public)
export const getCapacitaciones = async () => {
  const response = await api.get('/api/capacitaciones');
  return response.data;
};

// AI
export const generateAISummary = async (data) => {
  const response = await api.post('/api/ai/summary', data);
  return response.data;
};

export const reformulateQuestion = async (question, previousAnswers, context) => {
  const response = await api.post('/api/ai/reformulate', {
    question,
    previous_answers: previousAnswers,
    context,
  });
  return response.data;
};

export default api;
